export default "__VITE_ASSET__Bn2_aD3s__"